export default __webpack_public_path__ + "static/media/search.ede702e2.svg";